import {SummaryModel} from '../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../common/entity/permissions.model';
import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {EntityWithAuditMetadata} from '../../../../common/entity/entityWithAuditMetadata';
import {AccountSummary} from '../../../../../shared/model/account/accountSummary.model';
import {Moment} from 'moment';
import {ValueAndLabelModel} from "../../../../common/model/valueAndLabel.model";
import {PartnerSummaryModel} from "../../../../partner/common/api/model/partnerSummary.model";
import {InsolesSummaryCamDocumentModel} from "./insolesSummaryCamDocument.model";
import {InsoleMaterialSummaryModel} from "../../../material/api/entity/insoleMaterialSummary.model";
import {AddressModel} from "../../../../common/entity/address.model";
import {ProviderSummaryModel} from "../../../../provider/common/api/entity/providerSummary.model";

export class InsolesSummaryModel extends EntityWithAuditMetadata implements SummaryModel {
    permissions: PermissionsModel;
    id: number;
    businessId: string;
    status: LovValueSummary;
    color: LovValueSummary;
    customerAccount: AccountSummary;
    material: InsoleMaterialSummaryModel;
    patientName: string;
    symmetry: LovValueSummary;
    symmetrySubType: LovValueSummary;
    providerModel: ValueAndLabelModel;
    insoleModelProviderId: number;
    patient: PartnerSummaryModel;
    provider: ProviderSummaryModel;
    v2: boolean;
    feet: LovValueSummary;
    subscriptionId: number;
    covering: ValueAndLabelModel;
    scanGroupId: number;
    scanGroupNormalized: boolean;
    scanGroupRequiredManualValidation: boolean;
    cadWorkflowProcessStatus: LovValueSummary;
    lastCadProcessId: number;
    camMethod: LovValueSummary;
    renewType: LovValueSummary;

    talonnetteDocumentId: number;
    leftInsoleDocumentId: number;
    rightInsoleDocumentId: number;
    inError: boolean;
    productionDeadline: Moment;
    expectedDeliveryDate: Moment;
    orderedAt: Moment;

    comment: string;
    productionComment: string;
    accountId: number;
    deliveryAddress: AddressModel;
}

export enum InsolesStatus {
    INSOLE_STATUS_CREATED = 'INSOLE_STATUS_CREATED',
    INSOLE_STATUS_CREATED_WITH_SCAN = 'INSOLE_STATUS_CREATED_WITH_SCAN',
    INSOLE_STATUS_DESIGNED = 'INSOLE_STATUS_DESIGNED',
    INSOLE_STATUS_BEING_PRODUCED = 'INSOLE_STATUS_BEING_PRODUCED',
    INSOLE_STATUS_PRODUCED = 'INSOLE_STATUS_PRODUCED',
    INSOLE_STATUS_SENT = 'INSOLE_STATUS_SENT',
    INSOLE_STATUS_RECEIVED = 'INSOLE_STATUS_RECEIVED',
}
export enum InsolesView {
    CUSTOMER = 'CUSTOMER',
    PROVIDER = 'PROVIDER',
}
